import { styled } from "@mui/material";
import { Container, Grid, Avatar, Button, TextField } from "@mui/material";
import customTheme from "../../../material-ui/theme";

export const ContainerRoot = styled(Container)(() => ({
  padding: customTheme.spacing(2),
}));

export const GridCentered = styled(Grid)(() => ({
  justifyContent: 'center',
}));

export const AvatarNormal = styled(Avatar)(() => ({
  width: customTheme.spacing(3),
  height: customTheme.spacing(3),
  marginLeft: customTheme.spacing(2),
  borderRadius: 0,
}));

export const FormRoot = styled('form')(() => ({
  '& .MuiTextField-root': {
    margin: customTheme.spacing(1),
    minWidth: 200,
  },
}));

export const ButtonPrimary = styled(Button)(() => ({
  backgroundColor: customTheme.palette.primary.main,
  color: '#000',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: customTheme.palette.primary.main,
  },
}));

export const TextFieldStyled = styled(TextField)(() => ({

  // línea al hacer foco
  '& .MuiInput-underline:after': {
    borderBottomColor: customTheme.palette.primary.main,
  },
  // label al hacer foco
  '& label.Mui-focused': {
    color: customTheme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: customTheme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: customTheme.palette.primary.main,
  },
}));